module.exports = __webpack_public_path__ + "static/img/Store_V.2fd8877e.svg";